export default {"src":"/_next/static/media/location_icon_white.af3476a0.svg","height":18,"width":13,"blurWidth":0,"blurHeight":0};